import script from "./TongHopVatTuTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TongHopVatTuTable.vue?vue&type=script&lang=ts&setup=true"

import "./TongHopVatTuTable.vue?vue&type=style&index=0&id=ecd99f16&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecd99f16"]])

export default __exports__